import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { load } from 'webfontloader';
import CustomThemeProvider from './contexts/CustomThemeProvider';
import ReduxStoreProvider from './contexts/ReduxStoreProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './api/reactQueryClient/reactQueryClient';
import { initSentry, Sentry } from './utils/SentryHelper';

initSentry();

load({
  google: {
    families: ['Montserrat', 'Public Sans', 'Roboto', 'Inconsolata', 'Mirza'],
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_CUSTOM_DOMAIN as string}
      clientId={process.env.REACT_APP_AUTH0_CLIENT as string}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/login`,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <ReduxStoreProvider>
          <CustomThemeProvider>
            <BrowserRouter>
              <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
                <App />
              </Sentry.ErrorBoundary>
              <ReactQueryDevtools
                initialIsOpen={false}
                buttonPosition="bottom-right"
              />
            </BrowserRouter>
          </CustomThemeProvider>
        </ReduxStoreProvider>
      </QueryClientProvider>
    </Auth0Provider>
  </React.StrictMode>
);
